import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { APP_POPOVERS } from "./constant";
import type {
  PopoverState,
  TAppPopover,
  TPopoverIds,
  TPosition,
} from "./types";

const initialState: PopoverState = {
  appPopovers: APP_POPOVERS,
};

const popoverSlice = createSlice({
  name: "popover",
  initialState,
  reducers: {
    updatePopover: (state, action: PayloadAction<TAppPopover>) => {
      const { id, info, isOpen, subtype, position } = action.payload;
      if (!id) return;
      state.appPopovers[id].info = info;
      state.appPopovers[id].isOpen = isOpen;
      state.appPopovers[id].subtype = subtype;
      state.appPopovers[id].position = position;
    },
    updatePopoverPosition: (
      state,
      action: PayloadAction<{ id: TPopoverIds; position: TPosition } | null>,
    ) => {
      if (!action.payload) return;
      const { id, position } = action.payload;
      state.appPopovers[id].position = position;
    },
  },
});

export const popoverReducers = popoverSlice.reducer;
export const { updatePopover, updatePopoverPosition } = popoverSlice.actions;
